<template>
  <b-container class="form-container bg-white shadow">
    <h3 class="col-12 text-dark py-4 mb-0">Create Account</h3>
    <p class="col-12 font-md pb-4">
      Please answer the following questions to create a FOResT User Account. Your account is
      required to create, submit and/or electronically 'sign' a Forest Operations Notification
      (FON). The system will generate a FOResT User Number for your account; this protects
      your details from general view. Please note that two accounts cannot be created with the
      same email address. Questions? Please contact MFS at
      <a href="mailto:forestinfo@maine.gov">forestinfo@maine.gov</a> or
      <a href="tel:207-287-2791">207-287-2791</a>.
    </p>
    <AccountForm
      :allowCancel="false"
      :edit="false"
      :initialAccount="account"
      @submitted="submitSuccess"
    />
    <b-modal
      ref="accountCreatedModal"
      id="accountCreatedModal"
      centered
      title="Account Created"
      no-close-on-esc
      no-close-on-backdrop
      ok-only
      hide-header-close
      @ok="$router.push({ name: 'home' })"
    >
      You're almost there!
      <br>
      <br>
      An email has been sent to you from
      <u>no-reply@timmonsgis.com</u> with a link that you must use to activate your account.
      <br>
      <br>
      Please check your email and follow the instructions so you can begin using FOResT.
      <br>
      <br>
      You should receive this email confirmation in just a few minutes.
      <br>
      <br>
      If you do not see it in your inbox:
      <ul>
        <li>
          Make sure your email is not blocking messages from <u>no-reply@timmonsgis.com</u>
        </li>
        <li>
          Also check your "spam", "junk", or other folders.
        </li>
      </ul>
    </b-modal>
  </b-container>
</template>

<script>
import AccountForm from '@/components/account/AccountForm.vue';
import { initialAddress } from '@/helpers';

export default {
  name: 'CreateAccount',
  components: {
    AccountForm,
  },
  data() {
    return {
      account: {
        firstName: '',
        middleName: '',
        lastName: '',
        companyName: '',
        email: '',
        password: '',
        phoneNumber: '',
        licensedForesterId: '',
        physicalAddress: initialAddress(),
        mailingAddress: initialAddress(),
        mailingSameAsPhysical: false,
        landowner: false,
      },
    };
  },
  methods: {
    submitSuccess() {
      this.$refs.accountCreatedModal.show();
    },
  },
};
</script>
